import * as L from "leaflet";
export const getDistanceInMeters = (pointA, pointB) => {
    return L.latLng(pointA.lat, pointA.lng).distanceTo(L.latLng(pointB.lat, pointB.lng));
};
